module.exports = __webpack_public_path__ + "img/payment.40fc4ec1.png";